import { useContext } from "react";
import {
  Button,
  Card,
  CardContent,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
  Tooltip,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import UploadIcon from "@mui/icons-material/Upload";
import TranslateIcon from "@mui/icons-material/Translate";
import HistoryIcon from "@mui/icons-material/History";
import CloseIcon from "@mui/icons-material/Close";
import UserContext from "../../context/user";
import { useHistory } from "react-router-dom";
import { BULKS_OPERATIONS_CONSTANTS } from "../../Constant/BulkOpsContant";
import "./styles.css";

const BulkOperationsModal = ({ open, onClose }) => {
  const history = useHistory();
  const UserInfo = useContext(UserContext);

  const renderIcon = (iconName) => {
    const icons = {
      SearchIcon,
      UploadIcon,
      TranslateIcon,
    };

    const IconComponent = icons[iconName];
    return IconComponent ? (
      <IconComponent fontSize="large" color="error" className="ops-icons" />
    ) : null;
  };
  return (
    <Dialog
      open={open}
      onClose={onClose}
      className="container extra-margin-top-less bulk-operations-modal text-transform-none"
    >
      <DialogTitle className="d-flex justify-content-between pb-0">
        {BULKS_OPERATIONS_CONSTANTS.HEADING}
        <CloseIcon className="close-icon" onClick={onClose} />
      </DialogTitle>
      <Typography variant="body2" color="textSecondary" className="px-4">
        {BULKS_OPERATIONS_CONSTANTS.SUB_HEADING}
      </Typography>
      <DialogContent className="pb-4">
        {BULKS_OPERATIONS_CONSTANTS.CARDS.map((card, index) => {
          const isDisabled = card.hasAccess && !UserInfo?.[card.hasAccess];
          return (
            <Tooltip title={isDisabled ? card.disabledTooltip : ""} arrow>
              <Card
                variant="outlined"
                className={
                  "card-option" +
                  (index === 0 ? " mt-0" : " mt-3") +
                  (isDisabled ? " disabled" : "")
                }
                key={index}
              >
                <CardContent
                  className="card-content"
                  onClick={() => {
                    if (isDisabled) {
                      return;
                    }
                    if (card.to) {
                      history.push(card.to);
                      onClose();
                    }
                  }}
                  aria-disabled={isDisabled}
                >
                  {renderIcon(card.icon)}
                  <div>
                    <Typography variant="body1" className="_wg-dynamic-text">
                      {card.title}
                    </Typography>
                    <Typography
                      variant="body2"
                      color="textSecondary"
                      className="_wg-dynamic-text"
                    >
                      {card.description}
                    </Typography>
                  </div>
                </CardContent>
              </Card>
            </Tooltip>
          );
        })}
        {(UserInfo?.canBulkUpload ||
          UserInfo?.canBulkSearch) && (
          <div className="d-flex justify-content-center">
            <Button
              onClick={() => {
                history.push("/upload-history");
                onClose();
              }}
              color="inherit"
              className="upload-history-btn"
              startIcon={<HistoryIcon />}
            >
              {BULKS_OPERATIONS_CONSTANTS.VIEW_UPLOAD_HISTORY_BUTTON}
            </Button>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default BulkOperationsModal;
